import { create } from 'zustand'

const useFeedbackStore = create((set) => ({
  isFeedback: false,
  setIsFeedback: (state) => set({ isFeedback: state })
}))

export default useFeedbackStore
